import { AnimatePresence, motion, useAnimation } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import './services.css';

const Services = () => {
  const [toggleState, setToggleState] = useState(null);
  const controls = useAnimation(); // kontrol animasi untuk elemen yang akan digerakkan
  const [scrollingDown, setScrollingDown] = useState(true);

  // Mengubah status scrolling ke bawah atau ke atas
  const handleScroll = () => {
    if (window.scrollY > 100) {
      setScrollingDown(true); // Scroll ke bawah
    } else {
      setScrollingDown(false); // Kembali ke atas
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll); // Membersihkan event listener saat komponen unmount
    };
  }, []);

  const toggleTab = (index) => {
    setToggleState(index === toggleState ? null : index); // Toggle modal visibility
  };

  const services = [
    {
      id: 1,
      icon: 'uil uil-code-branch',
      title: 'Full-Stack Development',
      description: 'Specializing in both front-end and back-end development, delivering high-quality web applications.',
      details: [
        'Develop scalable back-end systems',
        'Design and implement dynamic, interactive user interfaces',
        'Integrate third-party APIs and services',
        'Ensure cross-platform compatibility'
      ]
    },
    {
      id: 2,
      icon: 'uil uil-mobile-android',
      title: 'Mobile Application',
      description: 'Creating seamless and intuitive mobile applications with a focus on enhancing user experience.',
      details: [
        'Design and build mobile apps for Android and iOS',
        'Optimize for performance and user experience',
        'Implement native and cross-platform solutions',
        'Integrate mobile-specific features such as notifications'
      ]
    },
    {
      id: 3,
      icon: 'uil uil-palette',
      title: 'UI/UX Design',
      description: 'Creating intuitive and aesthetically pleasing user interfaces.',
      details: [
        'Conduct user research and usability testing',
        'Design wireframes, prototypes, and mockups',
        'Optimize user flows for simplicity and efficiency',
        'Implement visual design principles for consistency'
      ]
    }
  ];

  const cardVariants = {
    hover: {
      scale: 1.02,
      transition: {
        duration: 0.2,
        ease: "easeInOut"
      }
    }
  };

  const modalVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { duration: 0.2 }
    },
    exit: { 
      opacity: 0,
      transition: { duration: 0.2 }
    }
  };

  const modalContentVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { 
      scale: 1, 
      opacity: 1,
      transition: { 
        type: "spring",
        duration: 0.5
      }
    },
    exit: { 
      scale: 0.8, 
      opacity: 0,
      transition: { duration: 0.2 }
    }
  };

  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What I offer</span>

      <div className="services__container container grid">
        {services.map((service, index) => (
          <motion.div
            key={service.id}
            className="service__content"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ 
              opacity: 1, 
              y: 0,
              transition: {
                type: "spring",
                delay: index * 0.2,
                duration: 0.5
              }
            }}
            whileHover="hover"
            variants={cardVariants}
            viewport={{ once: true }}
          >
            <div>
              <i className={`uil ${service.icon} service__icon`}></i>
              <h3 className="service__title">{service.title}</h3>
            </div>
            <span
              className="service__button"
              onClick={() => toggleTab(service.id)}
            >
              View More
              <i className='uil uil-arrow-right service__button-icon'></i>
            </span>
          </motion.div>
        ))}
      </div>

      <AnimatePresence>
        {toggleState && (
          <motion.div 
            className="services__modal"
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setToggleState(null);
              }
            }}
          >
            <motion.div 
              className="service__modal-content"
              variants={modalContentVariants}
              onClick={(e) => e.stopPropagation()}
            >
              <i 
                className="uil uil-times services__modal-close" 
                onClick={() => setToggleState(null)}
              />
              <h3 className="services__modal-title">
                {services[toggleState - 1]?.title}
              </h3>
              <p className="services__modal-description">
                {services[toggleState - 1]?.description}
              </p>
              <ul className="services__modal-services grid">
                {services[toggleState - 1]?.details.map((detail, index) => (
                  <li className="services__modal-service" key={index}>
                    <i className="uil uil-check-circle services__modal-icon" />
                    <p className="services__modal-info">{detail}</p>
                  </li>
                ))}
              </ul>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Services;
